export const SET_AUTH = 'SET_AUTH'
export const SET_AUTH_KEY = 'SET_AUTH_KEY'
export const ADD_UPLOADED_FILE_TO_ATTACHMENT_SECTION = 'ADD_UPLOADED_FILE_TO_ATTACHMENT_SECTION'
